<template>
  <BaseTemplate app-name="" page-title="">
    <template #content>
      <div class="px-4 md:px-8 py-4 md:py-6 space-y-6">
        <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-800 px-4 py-4 md:px-6 md:py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div>
            <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
              Novidades do Sistema
            </h1>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Acompanhe as últimas melhorias, correções e atualizações aplicadas ao sistema.
            </p>
          </div>
          <div class="flex items-center gap-2">
            <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200">
              {{ novidades.length }} {{ novidades.length === 1 ? 'versão registrada' : 'versões registradas' }}
            </span>
          </div>
        </div>

        <div v-if="loading" class="text-gray-500 dark:text-gray-400">
          Carregando novidades...
        </div>

        <div v-else-if="novidades.length === 0" class="text-gray-500 dark:text-gray-400">
          Nenhuma novidade registrada até o momento.
        </div>

        <div v-else class="relative space-y-4 before:absolute before:bottom-2 before:left-[0.7rem] before:top-2 before:w-0.5 before:bg-gradient-to-b before:from-blue-600/20 before:to-transparent">
          <div
            v-for="(item, index) in novidades"
            :key="item.id"
            class="relative pl-9 bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 md:p-5"
          >
            <div class="absolute left-[0.35rem] top-[1.2rem] h-2.5 w-2.5 rounded-full bg-blue-500 ring-4 ring-blue-500/25"></div>
            <div class="flex flex-col md:flex-row md:items-start md:justify-between gap-2 mb-2">
              <div class="flex items-center flex-wrap gap-2">
                <span class="px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200">
                  Versão {{ item.versao }}
                </span>
                <span
                  v-if="index === 0"
                  class="px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-200"
                >
                  Mais recente
                </span>
              </div>
              <div class="text-xs text-gray-500 dark:text-gray-400 text-left md:text-right">
                <div>{{ formatDate(item.criado_em) }}</div>
                <div>{{ formatTime(item.criado_em) }}</div>
              </div>
            </div>
            <div class="text-xs text-gray-500 dark:text-gray-400 mb-2">
              Lançado por: <span class="font-semibold text-gray-700 dark:text-gray-200">{{ item.criado_por }}</span>
            </div>
            <div
              class="prose prose-strong:font-bold prose-sm dark:prose-invert max-w-none text-gray-800 dark:text-gray-100 mt-1"
              v-html="getTextoHtml(item)"
            ></div>
          </div>
        </div>
      </div>
    </template>
  </BaseTemplate>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import BaseTemplate from '../templates/BaseTemplate.vue';
import apiClient from '@/services/authService';

const novidades = ref([]);
const loading = ref(false);

function formatDate(isoString) {
  const d = new Date(isoString);
  return d.toLocaleDateString('pt-BR');
}

function formatTime(isoString) {
  const d = new Date(isoString);
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

function formatTextOnClient(texto) {
  if (!texto) return '';
  const partes = texto.split('*');
  let negrito = false;
  const resultado = [];
  for (const parte of partes) {
    if (negrito) {
      resultado.push(`<strong>${parte}</strong>`);
    } else {
      resultado.push(parte);
    }
    negrito = !negrito;
  }
  return resultado.join('');
}

function getTextoHtml(item) {
  if (!item) return '';
  const base = item.texto_formatado || formatTextOnClient(item.texto);
  if (!base) return '';
  return base.replace(/\n/g, '<br>');
}

async function carregarNovidades() {
  loading.value = true;
  try {
    const response = await apiClient.get('/api/v1/changelog/novidades');
    novidades.value = response.data || [];
  } catch (error) {
    console.error('Erro ao carregar novidades', error);
  } finally {
    loading.value = false;
  }
}

onMounted(() => {
  carregarNovidades();
});
</script>
